import { render, staticRenderFns } from "./urunlerDetail.vue?vue&type=template&id=0fe58e19&scoped=true&"
import script from "./urunlerDetail.vue?vue&type=script&lang=js&"
export * from "./urunlerDetail.vue?vue&type=script&lang=js&"
import style0 from "./urunlerDetail.vue?vue&type=style&index=0&id=0fe58e19&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0fe58e19",
  null
  
)

export default component.exports